import { createFileRoute } from "@tanstack/react-router";
import { CustomerSection } from "../../app/views/customer/customerSection";

export const Route = createFileRoute("/customer")({
  component: CustomerSection,
});
